import { render, staticRenderFns } from "./ClinicalForm.vue?vue&type=template&id=55221e2b"
import script from "./ClinicalForm.vue?vue&type=script&lang=js"
export * from "./ClinicalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports